import { APICore } from './apiCore';

const api = new APICore();

// Helper for query params
const toQuery = (q: any) => (q ? '?' + new URLSearchParams(q).toString() : '');

// --- Aircraft Management ---

export const listAircrafts = (q?: { 
  status?: 'DRAFT' | 'ACTIVE' | 'SUSPENDED' | 'ARCHIVED';
  perPage?: number;
  page?: number;
  tailNumber?: string;
  manufacturer?: string;
  jetClassCode?: string;
}) =>
  api.get(`/supplier-api/aircrafts${toQuery(q)}`, {});

export const createAircraft = (payload: any) => api.create('/supplier-api/aircrafts', payload);

export const getAircraft = (id: number) => api.get(`/supplier-api/aircrafts/${id}`, {});

export const updateAircraft = (id: number, payload: any) =>
  api.updatePatch(`/supplier-api/aircrafts/${id}`, payload);

export const archiveAircraft = (id: number) => api.delete(`/supplier-api/aircrafts/${id}`);

export const changeAircraftStatus = (id: number, status: 'DRAFT' | 'WAITING' | 'ACTIVE' | 'SUSPENDED' | 'ARCHIVED') =>
  api.updatePatch(`/supplier-api/aircrafts/${id}/status`, { status });

// --- Seat Maps ---

export const createSeatMapVersion = (id: number, seats: any[]) =>
  api.create(`/supplier-api/aircrafts/${id}/seat-maps`, { seats });

export const listSeatMapVersions = (id: number) => api.get(`/supplier-api/aircrafts/${id}/seat-maps`, {});

export const getActiveSeatMap = (id: number) => api.get(`/supplier-api/aircrafts/${id}/seat-maps/active`, {});

export const activateSeatMapVersion = (id: number, versionId: number) =>
  api.create(`/supplier-api/aircrafts/${id}/seat-maps/${versionId}/activate`, {});

// --- Media & Upload ---

export const uploadFile = (formData: FormData) => api.createWithFile('/supplier-api/documents/upload', formData);

export const attachImage = (id: number, payload: { fileId: number; primary?: boolean; isRepresentative?: boolean; caption?: string }) =>
  api.create(`/supplier-api/aircrafts/${id}/images`, payload);

export const removeImage = (id: number, imageId: number) => api.delete(`/supplier-api/aircrafts/${id}/images/${imageId}`);

export const reorderImages = (id: number, order: number[]) =>
  api.updatePatch(`/supplier-api/aircrafts/${id}/images/order`, { order });

export const attachDocument = (id: number, payload: { fileId: number; type: string }) =>
  api.create(`/supplier-api/aircrafts/${id}/documents`, payload);

export const removeDocument = (id: number, docId: number) => api.delete(`/supplier-api/aircrafts/${id}/documents/${docId}`);

export const listImages = (id: number) => api.get(`/supplier-api/aircrafts/${id}/images`, {});

export const listDocuments = (id: number) => api.get(`/supplier-api/aircrafts/${id}/documents`, {});

// --- Jet Classes ---

export const listJetClasses = () => api.get('/supplier-api/aircrafts/jet-classes', {});
